module.exports = __webpack_public_path__ + "img/skype.ef08720a.png";